import styles from '../pageLayout.module.css';

export default function LayeredButtonContainer({ buttonArray }) {
	return (
		<div className={styles.layeredButtonContainer}>
			<div className={styles.layeredButtons}>{buttonArray}</div>
		</div>
	);
}
